
import { defineComponent } from 'vue';
import { GlobalAlertTypes } from '@momnt-technologies/common-ui/lib/plugins/alerts/types';
import { AxiosError } from 'axios';
import Alert from '~/components/Alerts/Alert.vue';
import AuthLayout from '@/components/Layout/AuthLayout.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import PasswordInput from '@/components/common/Inputs/Password.vue';
import { isValidPassword } from '@/utils/validators';
import { resetAccountPassword } from '@/api/account';

export default defineComponent({
  name: 'ResetPassword',

  components: {
    Alert,
    AuthLayout,
    CustomButton,
    PasswordInput,
  },

  data: () => ({
    password: '',
    confirmPassword: '',
    errorMessage: '',
    loading: false,
  }),

  computed: {
    validForm() {
      return isValidPassword(this.password) && this.password === this.confirmPassword;
    }
  },

  methods: {
    async submit() {
      this.loading = true;
      try {
        await resetAccountPassword({
          password: this.password,
          password_check: this.confirmPassword,
          token: this.$route.query.token as string
        });
        this.$alerts.add({
          timed: true,
          type: GlobalAlertTypes.SUCCESS,
          text: 'Your password was reset successfully.'
        });
        this.$router.push({ name: 'login' });
      } catch (e) {
        const error = e as AxiosError;
        if (error.response?.status === 400) {
          this.errorMessage = error.response?.data.password[0];
        } else {
          this.errorMessage = 'We are unable to reset your password, please try again.';
        }
      } finally {
        this.loading = false;
        (this.$refs.resetPwdForm as HTMLFormElement).reset();
      }
    }
  }
});
